import { parseHoursOfOperation } from '../util/hoursOfOperation';

import styles from './HoursOfOperation.module.css';

export type HoursOfOperationProps = {
	hours?: string;
	icon?: JSX.Element;
};

export const HoursOfOperation = ({ hours, icon }: HoursOfOperationProps): JSX.Element => {
	const parsed = parseHoursOfOperation(hours ?? '');
	return (
		<div className={styles.iconBullet}>
			{icon && icon}
			<div className={styles.servicesHours}>
				{parsed.map((entry, i) => (
					<span key={i} className={styles.servicesText}>
						{entry}
					</span>
				))}
			</div>
		</div>
	);
};
